import React from 'react';
import LandlordToolkitLayout from '../../components/landlord-toolkit/LandlordToolkitLayout';
import ExpenseTracker from '../../components/landlord-dashboard/ExpenseTracker';

const ExpensesPage: React.FC = () => {
  return (
    <LandlordToolkitLayout title="Expense Tracker">
      <ExpenseTracker />
    </LandlordToolkitLayout>
  );
};

export default ExpensesPage;
